/*
// Cart Functions
// $("#cart-not").change(function(){
//   $("#cart-note-description").val("");
//   var getValue = $(this).val();
//   if(getValue == "")
//   {
//     $("#CartSpecialInstructions").html("");
//   }
//   else{
//     $("#CartSpecialInstructions").html(getValue);
//   }
//   if((getValue=="Newspaper/Magazine") || (getValue=="Other")){
//     $("textarea#cart-note-description").show();
//   }
//   else{
//     $("textarea#cart-note-description").hide();
//   }
// })
// $("#cart-note-description").focusout(function(){
//   var getcarthtml = $(this).val();
//   var cartnot =  $("#CartSpecialInstructions").val();
//   if((cartnot=="Newspaper/Magazine") || (cartnot=="Other")){
//     var totalnot = cartnot +": "+ getcarthtml;
//     $("#CartSpecialInstructions").html(totalnot);
//   }

// })
// $(".videotag").click(function(e){
//   e.preventDefault();
//   var getsrc = $(this).attr("data-altt");
//   $(".product-video .videoing").html('<source class="souring" src="'+getsrc+'" type="video/mp4">');
//   $(".product-video").css("display","block");
//   $(".product-video").find(".videoing").get(0).play();
//   $(".custom-products-main").css("display","none");
// })
// $(".normalImages").click(function(e){
//   e.preventDefault();
//   $(".product-video").find(".videoing").get(0).pause();
//   $(".custom-products-main").css("display","block");
//   $(".product-video").css("display","none");
// })

// Go to Top Button
// $(window).scroll(function() {

//   if I scroll more than 1000px...
//   if($(window).scrollTop() > 10){
//     $("button#myBtn").show();
//   }
//   else{
//     $("button#myBtn").hide();
//   }
// })

// if button is clicked, scroll to top
// $("button#myBtn").click(function(){
//   $('html, body').animate({ scrollTop: 0 }, 500);
// })
// $('body').on('click', '.cart__submit-controls>.cart__submit-control', function(e) {
// e.preventDefault();
//   window.location.href = "/checkout";
// })
/*!
 * parallax.js v1.4.2 (http://pixelcog.github.io/parallax.js/)
 * @copyright 2016 PixelCog, Inc.
 * @license MIT (https://github.com/pixelcog/parallax.js/blob/master/LICENSE)
 */
// !function(t,i,e,s){function o(i,e){var h=this;"object"==typeof e&&(delete e.refresh,delete e.render,t.extend(this,e)),this.$element=t(i),!this.imageSrc&&this.$element.is("img")&&(this.imageSrc=this.$element.attr("src"));var r=(this.position+"").toLowerCase().match(/\S+/g)||[];if(r.length<1&&r.push("center"),1==r.length&&r.push(r[0]),("top"==r[0]||"bottom"==r[0]||"left"==r[1]||"right"==r[1])&&(r=[r[1],r[0]]),this.positionX!=s&&(r[0]=this.positionX.toLowerCase()),this.positionY!=s&&(r[1]=this.positionY.toLowerCase()),h.positionX=r[0],h.positionY=r[1],"left"!=this.positionX&&"right"!=this.positionX&&(this.positionX=isNaN(parseInt(this.positionX))?"center":parseInt(this.positionX)),"top"!=this.positionY&&"bottom"!=this.positionY&&(this.positionY=isNaN(parseInt(this.positionY))?"center":parseInt(this.positionY)),this.position=this.positionX+(isNaN(this.positionX)?"":"px")+" "+this.positionY+(isNaN(this.positionY)?"":"px"),navigator.userAgent.match(/(iPod|iPhone|iPad)/))return this.imageSrc&&this.iosFix&&!this.$element.is("img")&&this.$element.css({backgroundImage:"url("+this.imageSrc+")",backgroundSize:"cover",backgroundPosition:this.position}),this;if(navigator.userAgent.match(/(Android)/))return this.imageSrc&&this.androidFix&&!this.$element.is("img")&&this.$element.css({backgroundImage:"url("+this.imageSrc+")",backgroundSize:"cover",backgroundPosition:this.position}),this;this.$mirror=t("<div />").prependTo("body");var a=this.$element.find(">.parallax-slider"),n=!1;0==a.length?this.$slider=t("<img />").prependTo(this.$mirror):(this.$slider=a.prependTo(this.$mirror),n=!0),this.$mirror.addClass("parallax-mirror").css({visibility:"hidden",zIndex:this.zIndex,position:"fixed",top:0,left:0,overflow:"hidden"}),this.$slider.addClass("parallax-slider").one("load",function(){h.naturalHeight&&h.naturalWidth||(h.naturalHeight=this.naturalHeight||this.height||1,h.naturalWidth=this.naturalWidth||this.width||1),h.aspectRatio=h.naturalWidth/h.naturalHeight,o.isSetup||o.setup(),o.sliders.push(h),o.isFresh=!1,o.requestRender()}),n||(this.$slider[0].src=this.imageSrc),(this.naturalHeight&&this.naturalWidth||this.$slider[0].complete||a.length>0)&&this.$slider.trigger("load")}function h(s){return this.each(function(){var h=t(this),r="object"==typeof s&&s;this==i||this==e||h.is("body")?o.configure(r):h.data("px.parallax")?"object"==typeof s&&t.extend(h.data("px.parallax"),r):(r=t.extend({},h.data(),r),h.data("px.parallax",new o(this,r))),"string"==typeof s&&("destroy"==s?o.destroy(this):o[s]())})}!function(){for(var t=0,e=["ms","moz","webkit","o"],s=0;s<e.length&&!i.requestAnimationFrame;++s)i.requestAnimationFrame=i[e[s]+"RequestAnimationFrame"],i.cancelAnimationFrame=i[e[s]+"CancelAnimationFrame"]||i[e[s]+"CancelRequestAnimationFrame"];i.requestAnimationFrame||(i.requestAnimationFrame=function(e){var s=(new Date).getTime(),o=Math.max(0,16-(s-t)),h=i.setTimeout(function(){e(s+o)},o);return t=s+o,h}),i.cancelAnimationFrame||(i.cancelAnimationFrame=function(t){clearTimeout(t)})}(),t.extend(o.prototype,{speed:.2,bleed:0,zIndex:-100,iosFix:!0,androidFix:!0,position:"center",overScrollFix:!1,refresh:function(){this.boxWidth=this.$element.outerWidth(),this.boxHeight=this.$element.outerHeight()+2*this.bleed,this.boxOffsetTop=this.$element.offset().top-this.bleed,this.boxOffsetLeft=this.$element.offset().left,this.boxOffsetBottom=this.boxOffsetTop+this.boxHeight;var t=o.winHeight,i=o.docHeight,e=Math.min(this.boxOffsetTop,i-t),s=Math.max(this.boxOffsetTop+this.boxHeight-t,0),h=this.boxHeight+(e-s)*(1-this.speed)|0,r=(this.boxOffsetTop-e)*(1-this.speed)|0;if(h*this.aspectRatio>=this.boxWidth){this.imageWidth=h*this.aspectRatio|0,this.imageHeight=h,this.offsetBaseTop=r;var a=this.imageWidth-this.boxWidth;this.offsetLeft="left"==this.positionX?0:"right"==this.positionX?-a:isNaN(this.positionX)?-a/2|0:Math.max(this.positionX,-a)}else{this.imageWidth=this.boxWidth,this.imageHeight=this.boxWidth/this.aspectRatio|0,this.offsetLeft=0;var a=this.imageHeight-h;this.offsetBaseTop="top"==this.positionY?r:"bottom"==this.positionY?r-a:isNaN(this.positionY)?r-a/2|0:r+Math.max(this.positionY,-a)}},render:function(){var t=o.scrollTop,i=o.scrollLeft,e=this.overScrollFix?o.overScroll:0,s=t+o.winHeight;this.boxOffsetBottom>t&&this.boxOffsetTop<=s?(this.visibility="visible",this.mirrorTop=this.boxOffsetTop-t,this.mirrorLeft=this.boxOffsetLeft-i,this.offsetTop=this.offsetBaseTop-this.mirrorTop*(1-this.speed)):this.visibility="hidden",this.$mirror.css({transform:"translate3d(0px, 0px, 0px)",visibility:this.visibility,top:this.mirrorTop-e,left:this.mirrorLeft,height:this.boxHeight,width:this.boxWidth}),this.$slider.css({transform:"translate3d(0px, 0px, 0px)",position:"absolute",top:this.offsetTop,left:this.offsetLeft,height:this.imageHeight,width:this.imageWidth,maxWidth:"none"})}}),t.extend(o,{scrollTop:0,scrollLeft:0,winHeight:0,winWidth:0,docHeight:1<<30,docWidth:1<<30,sliders:[],isReady:!1,isFresh:!1,isBusy:!1,setup:function(){if(!this.isReady){var s=t(e),h=t(i),r=function(){o.winHeight=h.height(),o.winWidth=h.width(),o.docHeight=s.height(),o.docWidth=s.width()},a=function(){var t=h.scrollTop(),i=o.docHeight-o.winHeight,e=o.docWidth-o.winWidth;o.scrollTop=Math.max(0,Math.min(i,t)),o.scrollLeft=Math.max(0,Math.min(e,h.scrollLeft())),o.overScroll=Math.max(t-i,Math.min(t,0))};h.on("resize.px.parallax load.px.parallax",function(){r(),o.isFresh=!1,o.requestRender()}).on("scroll.px.parallax load.px.parallax",function(){a(),o.requestRender()}),r(),a(),this.isReady=!0}},configure:function(i){"object"==typeof i&&(delete i.refresh,delete i.render,t.extend(this.prototype,i))},refresh:function(){t.each(this.sliders,function(){this.refresh()}),this.isFresh=!0},render:function(){this.isFresh||this.refresh(),t.each(this.sliders,function(){this.render()})},requestRender:function(){var t=this;this.isBusy||(this.isBusy=!0,i.requestAnimationFrame(function(){t.render(),t.isBusy=!1}))},destroy:function(e){var s,h=t(e).data("px.parallax");for(h.$mirror.remove(),s=0;s<this.sliders.length;s+=1)this.sliders[s]==h&&this.sliders.splice(s,1);t(e).data("px.parallax",!1),0===this.sliders.length&&(t(i).off("scroll.px.parallax resize.px.parallax load.px.parallax"),this.isReady=!1,o.isSetup=!1)}});var r=t.fn.parallax;t.fn.parallax=h,t.fn.parallax.Constructor=o,t.fn.parallax.noConflict=function(){return t.fn.parallax=r,this},t(e).on("ready.px.parallax.data-api",function(){t('[data-parallax="scroll"]').parallax()})}(jQuery,window,document);


// $(function() {
//   $('.swatch :radio').change(function() {
//     var optionIndex = $(this).closest('.swatch').attr('data-option-index');
//     var optionValue = $(this).val();
//     $(this)
//     .closest('form')
//     .find('.single-option-selector')
//     .eq(optionIndex)
//     .val(optionValue)
//     .trigger('change');
//   });
// });

// $(document).ready(function(){
//   $('.parallax-window').parallax({
//     zIndex:0,
//     positionY:'-50px'
//   });
//   $(window).trigger('resize').trigger('scroll');

//   $('.parallax-window-image-bar').parallax({
//     zIndex:0,
//     positionY:'-50px'
//   });

// })

$(document).ready(function(){

  // close the popups
  $(".overlaydiv, .closeimage > img, .closeimage, input.getconfirmation").click(function(){
    $(".overlaydiv, .popupdiv, .size_chart_image, .madetoorder, .read_more_info_popup, .hem_popup, .video_popup").fadeOut();
  })

  // On click of product inside lookbook == show slider
  // $(".lookbook_pro").click(function(){
  //   $('#slidercontent').html("");
  //   $(this).children(".lookbook_pro_diff_images").children(".lookbook_pro_diff_images_slider").clone().appendTo('#slidercontent');
  //   $(".overlaydiv, .popupdiv").fadeIn();
  //   $("#slidercontent .lookbook_pro_diff_images_slider").slick({
  //     arrows:true,
  //     autoplay:false
  //   });

  // })
  // onclick of size chart, show size chart popup
  // $(".size_chart").click(function(){

  //   $(".overlaydiv, .size_chart_image").fadeIn();
  // })
  // onclick of size chart, show size chart popup
  // $(".read_more_inner").click(function(){

  //   $(".overlaydiv, .read_more_info_popup").fadeIn();
  // })
  // onclick of hem adjustment, show popup
  $(".hemadjustment").click(function(){

    $(".overlaydiv, .hem_popup").fadeIn();
  })

  $(".product-thumbnails__item-link.video").click(function(e){

    e.preventDefault();
    let video_code = e.currentTarget.dataset.thumbnailId;
    let video_el = e;

    // let media = $(`.media[data-media-id=${video_code}]`).html()
    // $(".video_popup .inner_contnt").replaceWith(media);
    // $(".overlaydiv, .video_popup").fadeIn();
  })


  // Donation Function
  // $(".cart__submit-controls input.btn").click(function(e){
  //   if ($('input#checkbox_id').is(':checked')) {
  //     var checkalready = $('input#checkbox_id').attr("data-added");
  //     if(checkalready == 'already'){
  //       var donval = $("select.donationvalue").val();
  //       var checkalreadyid = $('input#checkbox_id').attr("data-id");
  //       if(donval == checkalreadyid){
          
  //       }
  //       else {
  //         e.preventDefault();
  //         $.ajax({
  //           type: 'POST',
  //           url: '/cart/change.js',
  //           data: 'quantity=0&id='+checkalreadyid,
  //           dataType: 'json',
  //           async:false,
  //           success: function(data) {
  //             $.ajax({
  //               type: 'POST',
  //               url: '/cart/add.js',
  //               data: 'quantity=1&id=' + donval,
  //               dataType: 'json',
  //               success: function(line_item) { 
  //                 window.location.href= '/checkout' ;
  //               }
  //             })
  //           }
  //         })
  //       }
  //     }else{
  //       e.preventDefault();
  //       var donval = $("select.donationvalue").val();
  //       $.ajax({
  //         type: 'POST',
  //         url: '/cart/add.js',
  //         data: 'quantity=1&id=' + donval,
  //         dataType: 'json',
  //         success: function(line_item) { 
  //           window.location.href= '/checkout' ;
  //         }
  //       })
  //     }
  //   }
  //   else{
  //     var checkalready = $('input#checkbox_id').attr("data-added");
  //     var checkalreadyid = $('input#checkbox_id').attr("data-id");
  //     if(checkalready == 'already'){
  //       e.preventDefault();
  //       $.ajax({
  //         type: 'POST',
  //         url: '/cart/change.js',
  //         data: 'quantity=0&id='+checkalreadyid,
  //         dataType: 'json',
  //         async:false,
  //         success: function(data) {
  //           window.location.href="/checkout";
  //         }
  //       })
  //     }
  //   }
  // })

  // Product Tabs
  // $(".tab_row .tab_title").click(function(e){
  //   $(this).parents(".tab_row").toggleClass("activenow");
  //   $(this).siblings(".tab_description").slideToggle();
  // })
})

$(document).ready(function() {

  // Mobile Filter for collection
  // if ($(window).width() < 767) {
  //   $(".filterhead").on('click', function(){
  //     $(this).toggleClass("dropbar_opened");
  //     $(".sidebar-blocks").slideToggle();
  //   })
  // }

  // Filter for Collection
  // $(".filter_heading").on('click', function(){
  //   $(this).toggleClass("filter_opened");
  //   $(this).siblings(".filter_options").slideToggle();
  // })

  // Getting the values from the Tags and Assigning the Values as options
  // $(".tagsGetting").each(function(){
  //     var CurrentTagGet = $(this).html();
  //     $(".sidebar_filters").each(function(){
  //       $(this).children(".filter_options").children("span").each(function(){
  //         var GetTags= $(this).attr("data-tags");
  // if(CurrentTagGet==GetTags)
  // {
  // $(this).addClass("active-tags");
  // }
  
  //       })
  //     })
  //   })

  // On Click Filter Options
  // $('body').on('click', '.filter_options span', function() {
    
  //   var CurrentTagLength = ($(".No-tag").length);
  //   console.log(CurrentTagLength);
  //   var currentClickTag = $(this).attr("data-tags");
  //   if(CurrentTagLength==1){
  //     console.log("IF");
  //     var getcolurl = $("#collection_url").html();
  //     getcolurl = getcolurl+"/"+currentClickTag ;
  //     window.location.href=getcolurl;
  //   } else {
  //      var Newselectedfilters = '';
  //     var getcolurl = $("#collection_url").html();
  //     if($(this).hasClass("active-tags")){
  //     $(this).removeClass("active-tags");
  //       $(".active-tags").each(function(){
  //     var GetTags = $(this).attr("data-tags");
  //       GetTags = GetTags.replace(/ /g,"-");
  //       GetTags = GetTags.replace("/","-");
  //       Newselectedfilters = Newselectedfilters +"+"+GetTags;
  //       console.log(Newselectedfilters);
  //     })
  //   }
  //     else{
     
  //     $(this).siblings("span").removeClass("active-tags");
  //     $(this).addClass("active-tags");
  //     $(".active-tags").each(function(){
  //     var GetTags = $(this).attr("data-tags");
  //       GetTags = GetTags.replace(/ /g,"-");
  //       GetTags = GetTags.replace("/","-");
  //       Newselectedfilters = Newselectedfilters +"+"+GetTags;
  //       console.log(Newselectedfilters);
  //     })
     
  //     }
  //      getcolurl = getcolurl+"/"+Newselectedfilters
  //     getcolurl = getcolurl.replace("/+","/");
  //     window.location.href=getcolurl;
  //   }
  //   var getallselectedfilters = '';
  //   var checkindex= 0;
  //   if($(this).hasClass("active_filter")){
  //     $(this).removeClass("active_filter");
  //   }
  //   else{
  //     $(this).addClass("active_filter");
  //   }
  //   $(".active_filter").each(function(){
  //     if(checkindex== 0){
  //       getallselectedfilters = $(this).attr("data-tag");
  //       getallselectedfilters = getallselectedfilters.replace(/ /g,"-");
  //       getallselectedfilters = getallselectedfilters.replace("/","-");
  //     }
  //     else{
  //       getallselectedfilters = getallselectedfilters+"+"+$(this).attr("data-tag");
  //     }
  //     checkindex= parseInt(checkindex)+1;
  //   })
  //   var getcolurl = $("#collection_url").html();
  //   getcolurl = getcolurl+"/"+getallselectedfilters ; 
  //   //alert("getallselectedfilters="+getcolurl);
  //  // window.location.href=getcolurl;

  // });

  // $(".sample_pro").click(function(){
    
  //   var selectedvalue = $("select#ProductSelect-product-template").children("option:selected").html();
  //   console.log("selectedvalue="+selectedvalue);
  //   selectedvalue = selectedvalue.replace(/\s/g, '');
  //   $("input.hidvariants").each(function(){
  //     var gettitle = $(this).attr("data-title");
  //     gettitle = gettitle.replace(/\s/g, '');
  //     if(gettitle == selectedvalue){
  //       var getid = $(this).val();
  //       console.log("getid="+getid);
  //       $.ajax({
  //         type: 'POST',
  //         url: '/cart/add.js',
  //         data: 'quantity=1&id=' + getid,
  //         dataType: 'json',
  //         success: function(line_item) { 
  //           window.location.href= '/cart' ;
  //         }
  //       })
  //     }
  //   })
  // })

  
  // Onclick of Sizes Selection Do this
  //$('body').on('click', '.product-form__chip', function () {

    // codes that are not being used on the new template
    // var selectedvalue = $(".product-form__chip .selected").html();
    
    // selectedvalue = selectedvalue.replace(/\s/g, '');
    // console.log("selectedvalue="+selectedvalue);
    // $("input.hidvariants").each(function(){
    //   var gettitle = $(this).attr("data-title");
    //   gettitle = gettitle.replace(/\s/g, '');
    //   if(gettitle == selectedvalue){
    //     var sample_pro = $(this).attr("data-price");
    //     console.log("sample_pro="+sample_pro);
    //     $(".sample_pro span").remove();
    //     $(".sample_pro").append(sample_pro);
    //   }
    // })

    // Onclick Made to Order Buttons, Show the popup confirmation
   // var checklabel = $(this).attr("aria-label");

   // console.log(checklabel)
   // console.log(typeof(checklabel))
  //  if(checklabel.indexOf("made to order") != -1){
   //   //alert("test");
   //   $("input.getconfirmation"). prop("checked", false);
//
   //   $(".overlaydiv, .madetoorder").fadeIn();
   // }

  //})

  // Clicking the Choose Style Button Inside the Hem Popup Will Show the Content
  $(".choosestylebtn").click(function(){
    $(this).siblings(".choosestyledropdown").slideToggle();
  })

  $(".categoriesdrop.firstinner").click(function(){
    $(".coninputbox.secondchoice").hide();
    $(".coninputbox.firstchoice").slideDown();
    $(".bottombtn").show();
  })

  $(".categoriesdrop.secondinner").click(function(){
    $(".coninputbox.firstchoice").hide();
    $(".coninputbox.secondchoice").slideDown();
    $(".bottombtn").show();
  })

  $(".categoriesdrop").click(function(e){
    $(".activeclass").removeClass("activeclass");
    $(this).addClass("activeclass");
  })

  // Submitting the form in hem adjustment, do this
  $(".bottombtnsubmit").click(function(){
    var getsubmitteddata = '';
    if($( ".activeclass" ).hasClass( "firstinner" )){
      var gethtml = $(".activeclass").html();
      
      getsubmitteddata = gethtml+":"+$("input.firstcatbox").val();
      console.log(getsubmitteddata)
    }
    if($( ".activeclass" ).hasClass( "secondinner" )){
      var gethtml = $(".activeclass").html();
      getsubmitteddata = gethtml+":"+$("input.secondcatbox").val();
    }
    $(".overlaydiv, .hem_popup").fadeOut();
    $(".passcustominfo").val(getsubmitteddata);
    var customInfo = $(".passcustominfo").val;
    console.log(customInfo)
    console.log("getsubmitteddata="+getsubmitteddata);
    $(".product-form__cart-submit").addClass("addonemore");
    $(".product-form__cart-submit").removeAttr("type");
  })

})


$(".product-form__cart-submit").click(function(e){
  
  // if ( $( this ).hasClass( "addonemore" ) ) {

  //   $.ajax({
  //     type: 'POST',
  //     url: '/cart/add.js',
  //     data: 'quantity=1&id=32064508264561',
  //     dataType: 'json',
  //     success: function(line_item) { 

  //       // console.log("response is " + JSON.stringify(line_item))
  //       //working
  //       // $.ajax({
  //       //   type: 'POST',
  //       //   url: '/cart/add.js',
  //       //   data:$(".product-form").serialize(),
  //       //   dataType: 'json',
  //       //   success: function(response){
          
  //       //     // $.ajax({
  //       //     //   type: 'GET',
  //       //     //   url: '/cart.js',
  //       //     //   dataType: 'json',
  //       //     //   success: function(cartdata){
  //       //     //     $('div#CartCount').html(cartdata.item_count);
  //       //     //     $.ajax({
  //       //     //       type: "GET",
  //       //     //       url: "/cart",
  //       //     //       dataType: 'html',

  //       //     //       success: function(data) 
  //       //     //       {
  //       //     //         var minicartdata=$(data).filter('#slidingcartmain').html();
  //       //     //         $('#slidingcartmain').html(minicartdata);
  //       //     //         $("#overlay").addClass("is-active");
  //       //     //         $(".inline-cart").addClass("is-active");
  //       //     //       }
  //       //     //     });
  //       //     //   }

  //       //     // });
  //       //   },
  //       //   error: function(resp) 
  //       //   {
  //       //     var getres = JSON.stringify(resp);

  //       //     console.log("there is an error" + resp.responseJSON.description);
  //       //     console.log(getres)


  //       //   }
  //       // });
  //         // $(".product-form").submit();
  //     }
  //   })


  // }
  // else{
  //   $.ajax({
  //     type: 'POST',
  //     url: '/cart/add.js',
  //     data:$(".product-form").serialize(),
  //     dataType: 'json',
  //     success: function(response){
  //       $.ajax({
  //         type: 'GET',
  //         url: '/cart.js',
  //         dataType: 'json',
  //         success: function(cartdata){
  //           // $('div#CartCount').html(cartdata.item_count);
  //           // $.ajax({
  //           //   type: "GET",
  //           //   url: "/cart",
  //           //   dataType: 'html',

  //           //   success: function(data) 
  //           //   {
  //           //     var minicartdata=$(data).filter('#slidingcartmain').html();
  //           //     $('#slidingcartmain').html(minicartdata);
  //           //     $("#overlay").addClass("is-active");
  //           //     $(".inline-cart").addClass("is-active");
  //           //   }
  //           // });
  //         }

  //       });
  //     },
  //     error: function(resp) 
  //     {
  //       var getres = JSON.stringify(resp);

  //       alert(resp.responseJSON.description);



  //     }
  //   });
  //   // $(".product-form").submit();
  // }
  // $(".product-form").submit(function(e){
  //     e.preventDefault();
  //   });
})

// $(document).ready(function(){
//   $(".bookprivateappointmentinner").click(function(){
//     $(".contact-form.form-vertical.bookanappointment_bottom").toggle();
//   })
// })

// ======================= SLIDING CART STARTS HERE===============================================

// $(document).ready(function(){
//   console.log("ihkhikhi");
//   $(".plusquantity.qntyadjst").click(function(){
//     var newQty = +($(this).siblings("input").val()) + 1;
//     $(this).siblings("input").val(newQty);
//   });

//   $(".minusquantity.qntyadjst").click(function(){
//     var newQty = +($(this).siblings("input").val()) - 1;
//     if(newQty < 0)newQty = 0;
//     $(this).siblings("input").val(newQty);
//   });




//   $(".overlayimg").click(function(){
//     $(".main-image").fadeOut();
//     $(".overlayimg").fadeOut();
//   });

//   $(".crossdiv").click(function(){
//     $(".main-image").fadeOut();
//     $(".overlayimg").fadeOut();
//   });


// })

// Set the currency to a default based on a landing page
// $(window).load(function(){

//   $('body').on('click', 'a.site-header__icon.site-header__cart', function(e){

//     e.preventDefault();
//     $("#overlay").addClass("is-active");
//     $(".inline-cart").addClass("is-active");
//   })

//   $('body').on('click', '.close-cart-img', function(e){
//     e.preventDefault();
//     $("#overlay").removeClass("is-active");
//     $(".inline-cart").removeClass("is-active");
//   })

//   $('body').on('click', '.continueshopping', function(e){
//     e.preventDefault();
//     $("#overlay").removeClass("is-active");
//     $(".inline-cart").removeClass("is-active");
//   })

//   $('body').on('click', '#overlay', function(){
//     $("#overlay").removeClass("is-active");
//     $(".inline-cart").removeClass("is-active");
//   })

// })

// currently not working, but the purpose is changing the value of the cart from the header.
// $(document).ready(function(){
//   $('body').on('change', '.changequantity', function(){
//     var getline = $(this).attr("data-line-item-index");
//     var getval = $(this).val();


//     $.ajax({
//       type: 'POST',
//       url: '/cart/change.js',
//       data:  'quantity=' + getval + '&line=' + getline,
//       dataType: 'json',

//       success: function(data) 
//       {
//         if(data.item_count > 0){
//           $('.site-header__cart #CartCount').html(data.item_count);          

//         } else {
//           $('.site-header__cart #CartCount').html(data.item_count) ;         
//         }

//         $.ajax({
//           type: "GET",
//           url: "/cart",
//           dataType: 'html',

//           success: function(data) 
//           {
//             console.log("syncCart");
//             // console.log(data);
//             var minicartdata=$(data).filter('#slidingcartmain').html();
//             // console.log(minicartdata);
//             $('#slidingcartmain').html(minicartdata);
//             $("#overlay").addClass("is-active");
//             $(".inline-cart").addClass("is-active");
//           }
//         })
//       },
//       error: function(resp) 
//       {
//         var getres = JSON.stringify(resp);

//         alert(resp.responseJSON.description);



//       }
//     })

//   })


// })


// function remove(line, quantity){
//   $.ajax({
//     type: 'POST',
//     url: '/cart/change',
//     data: 'quantity='+quantity+'&line='+line,
//     dataType: 'json',
//     success: function(response){
//       $.ajax({
//         type: 'GET',
//         url: '/cart.js',
//         dataType: 'json',
//         success: function(cartdata){
//           $('.site-header__cart #CartCount').html(cartdata.item_count);
//           $.ajax({
//             type: "GET",
//             url: "/cart",
//             dataType: 'html',

//             success: function(data) 
//             {
//               var minicartdata=$(data).filter('#slidingcartmain').html();
//               $('#slidingcartmain').html(minicartdata);

//             }
//           });
//         }
//       });
//     }
//   });
// }
// $(document).ready(function(){
//   $("img.closebar").click(function(){
//     $(this).hide();
//     $(this).siblings(".promotionaltext.lightboxdisplay").hide();
//     $(".home-slideshow.content-width").addClass("pickup");
//   })

//   //   $("button#AddToCart-product-template").click(function(e){
//   //     console.log("qwedsa");
//   //     e.preventDefault();
//   //     $.ajax({
//   //       type: 'POST',
//   //       url: '/cart/add.js',
//   //       data:$(".product-form").serialize(),
//   //       dataType: 'json',
//   //       success: function(response){
//   //         $.ajax({
//   //           type: 'GET',
//   //           url: '/cart.js',
//   //           dataType: 'json',
//   //           success: function(cartdata){
//   //             $('.site-header__cart #CartCount').html(cartdata.item_count);
//   //             $.ajax({
//   //               type: "GET",
//   //               url: "/cart",
//   //               dataType: 'html',

//   //               success: function(data) 
//   //               {
//   //                 var minicartdata=$(data).filter('#slidingcartmain').html();
//   //                 $('#slidingcartmain').html(minicartdata);
//   //                 $("#overlay").addClass("is-active");
//   //                 $(".inline-cart").addClass("is-active");
//   //               }
//   //             });
//   //           }

//   //         });
//   //       },
//   //       error: function(resp) 
//   //       {
//   //         var getres = JSON.stringify(resp);

//   //         alert(resp.responseJSON.description);



//   //       }
//   //     });
//   //   })
// })


// ======================= SLIDING CART ENDS HERE===============================================

  $(document).ready(function(){
    $(".product-form__inner .accordion.accordion--active .accordion__text a").click(function(e){
      console.log("testingit");
      e.preventDefault(); 
      var url = $(this).attr('href'); 
      window.open(url, '_blank');
    })
    console.log("testingi2t");
   // $("<div>mydiv</div>").insertBefore('.mobile-sub .s2_error');
    $("div#drawer-menu__search").insertBefore("div#header");

    $(".search_icon").click(function(){
      $("div#drawer-menu__search").toggleClass("show");
    })
    
    $('body').on('click', 'div#drawer-menu__search a.drawer-menu__search-close', function() {
      $("div#drawer-menu__search").removeClass("show");
    })

      $('body').on('click', '.size_guide_popup', function() {
      $(".size_guide_overlay, .size_guide_content").fadeIn();
    })
    $(".close_icon, .size_guide_overlay").click(function(){
      $(".size_guide_overlay, .size_guide_content").fadeOut();
    })
    // Update ATC button to made to order specific to variant metafield

    var first_selected_id = $(".variant_selected_atc input.variant_id").val();
    $(".pro_variants input.variant_id_inner").each(function(){
      var valuee = $(this).val();
      var checkstatus = $(this).attr("data-metafield");
      if(valuee == first_selected_id){
        if(checkstatus == "true"){
          $(".product-form__submit-button-wrapper span[data-add-to-cart-text]").html("Buy Now Made-to-Order");
        } 
      }
    })

    $("ul.drawer-menu__list.drawer-menu__list--sub.drawer-menu__list--country-selector").insertAfter("header.header-container");

    
    $("div#currency_dropdown").click(function(){
      $("header.header-container + ul.drawer-menu__list").toggleClass("visible");
    })

    
    $(".mission_statement").parents(".mega-navigation").addClass("hasmissionstatement");
 //   $("#source").prependTo("#destination");

    $(".hasmissionstatement").each(function(){
      $(this).children(".mission_statement").prependTo($(this));
    })


    // menu mobile
    $(".drawer-menu__list.drawer-menu__list--sub li.drawer-menu__item").each(function(){
      var innerhtml = $(this).children("ul").html();
      if(innerhtml != undefined){
      $('<div class="inner_html"><ul>'+innerhtml+'</ul></div>').appendTo($(this));
      }
    })
  })

  

